import type {
  MondayBoardContext,
  MondayPlan,
  MondayServiceType,
  MondaySubscription,
  MondayUser,
} from "@/services/monday";
import { Theme } from "@/services/monday";

export interface MondayMockParams {
  boardId?: number;
  mondaySessionToken?: string;
  user?: MondayUser;
  subscription?: MondaySubscription;
  plan?: MondayPlan;
  slug?: string;
}

export function createMondayServiceMock(
  {
    boardId = 123,
    mondaySessionToken = "mock-session-token",
    user = baseMondayUser,
    subscription = baseSubscription,
    plan = baseMondayPlan,
    slug = "mock-slug",
  } = {} as MondayMockParams
): MondayServiceType {
  return {
    fetchSessionToken: () => Promise.resolve(mondaySessionToken),
    refreshSessionToken: () => Promise.resolve(mondaySessionToken),
    fetchBoardContext: () =>
      Promise.resolve({
        ...baseBoardContext,
        subscription,
        user,
        boardId,
      } as MondayBoardContext),
    fetchMondayPlan: () => Promise.resolve(plan),
    fetchAccountSlug: () => Promise.resolve(slug),
    accountSlug: slug,
    listenToBoardContext: () => () => {
      console.log("listenToBoardContext mock");
    },
  };
}

export const baseMondayUser: MondayUser = {
  id: "123",
  isViewOnly: false,
  isGuest: false,
  isAdmin: false,
};

export const baseSubscription: MondaySubscription = {
  plan_id: "pro",
  is_trial: true,
  renewal_date: "2021-01-01",
  billing_period: "monthly",
  days_left: -1,
};

export const baseBoardContext: MondayBoardContext = {
  boardId: 123,
  workspaceId: 456,
  theme: Theme.LIGHT,
  user: baseMondayUser,
  account: {
    id: "123",
  },
  app: {
    id: "123",
    clientId: "foo",
  },
  subscription: baseSubscription,
  appVersion: {
    versionData: {
      major: 1,
      minor: 2,
      patch: 3,
    },
  },
};

export const baseMondayPlan: MondayPlan = {
  max_users: 10,
  period: "monthly",
  tier: "pro",
  version: 9,
};
